<template>
  <a-drawer
    width="60%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
    >
      <!-- <a-page-header
        title="设置时间"
        sub-title="Set time"
      >
        <a-row style='display: flex;width: 100%'>
          <a-col :span="24">
            <a-form-model-item label="设置时间功能开关" prop="setTimeFunctionSwitch" >
              <a-switch v-model="form.setTimeFunctionSwitch" checked-children="开" un-checked-children="关" @change="onChange" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="设置当前时间"
              prop="setCurrentTime"
            >
              <a-date-picker
                valueFormat="YYYY-MM-DD HH:mm:ss"
                showTime
                v-model="form.setCurrentTime"
                style='width: 100%;'
                placeholder="请选择设置当前时间"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="通断开启时间"
              prop="onOffOnTime"
            >
              <a-date-picker
                valueFormat="YYYY-MM-DD HH:mm:ss"
                showTime
                v-model="form.onOffOnTime"
                style='width: 100%;'
                placeholder="请选择通断开启时间"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-page-header> -->
      <a-page-header
        title="设置采集参数和4g上传周期"
        sub-title="Set collection parameters and 4G upload cycle"
      >
        <a-row style='display: flex;width: 100%'>
          <a-col :span="24">
            <a-form-model-item
              label="开启功能设置"
              prop="collectParamFunctionSwitch"
            >
              <a-switch
                v-model="form.collectParamFunctionSwitch"
                checked-children="开"
                un-checked-children="关"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="4G上传周期（S）"
              prop="uploadCycleSeconds4g"
            >
              <a-input-number
                v-model="form.uploadCycleSeconds4g"
                :min="0"
                style='width: 100%;'
                placeholder="请输入4G上传周期（S）"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="设置通断周期（S）"
              prop="onOffCycleSeconds"
            >
              <a-input-number
                v-model="form.onOffCycleSeconds"
                :min="0"
                style='width: 100%;'
                placeholder="请输入设置通断周期（S）"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="断电间隔（MS）"
              prop="powerOutageIntervalMillisecond"
            >
              <a-input-number
                v-model="form.powerOutageIntervalMillisecond"
                :min="0"
                style='width: 100%;'
                placeholder="请输入断电间隔"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="通电延时（MS）"
              prop="powerOnDelayMillisecond"
            >
              <a-input-number
                v-model="form.powerOnDelayMillisecond"
                :min="0"
                style='width: 100%;'
                placeholder="请输入通电延时"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="断电延时（MS）"
              prop="offDelayOperationMillisecond"
            >
              <a-input-number
                v-model="form.offDelayOperationMillisecond"
                :min="0"
                style='width: 100%;'
                placeholder="请输入断电延时"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="低功耗采集（S）"
              prop="lowPowerAcquisitionMinute"
            >
              <a-input-number
                v-model="form.lowPowerAcquisitionMinute"
                :min="0"
                style='width: 100%;'
                placeholder="低功耗采集"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <!-- <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="运行时间（S）"
              prop="runTimeSeconds"
            >
              <a-input-number
                v-model="form.runTimeSeconds"
                :min="0"
                style='width: 100%;'
                placeholder="请输入运行时间（0-3600S）"
              />
            </a-form-model-item>
          </a-col>
        </a-row> -->
      </a-page-header>
<!--      <a-page-header-->
<!--        title="设置监控参数"-->
<!--        sub-title="Set monitoring parameters"-->
<!--      >-->
<!--        <a-row style='display: flex;width: 100%'>-->
<!--          <a-col :span="24">-->
<!--            <a-form-model-item-->
<!--              label="开启功能设置"-->
<!--              prop="setMonitorParamFunctionSwitch"-->
<!--            >-->
<!--              <a-switch-->
<!--                v-model="form.setMonitorParamFunctionSwitch"-->
<!--                checked-children="开"-->
<!--                un-checked-children="关"-->
<!--              />-->
<!--            </a-form-model-item>-->
<!--          </a-col>-->
<!--        </a-row>-->
<!--        <a-row style='display: flex;width: 100%'>-->
<!--          <a-col :span="11">-->
<!--            <a-form-model-item-->
<!--              label="报警电压高限位（V）"-->
<!--              prop="alarmVoltageHighLimit"-->
<!--            >-->
<!--              <a-input-number-->
<!--                v-model="form.alarmVoltageHighLimit"-->
<!--                :min="0"-->
<!--                style='width: 100%;'-->
<!--                placeholder="请输入报警电压高限位（0-20V）"-->
<!--              />-->
<!--            </a-form-model-item>-->
<!--          </a-col>-->
<!--          <a-col :span="2"></a-col>-->
<!--          <a-col :span="11">-->
<!--            <a-form-model-item-->
<!--              label="报警电压低限位（V）"-->
<!--              prop="alarmVoltageLowLimit"-->
<!--            >-->
<!--              <a-input-number-->
<!--                v-model="form.alarmVoltageLowLimit"-->
<!--                :min="-10"-->
<!--                style='width: 100%;'-->
<!--                placeholder="请输入报警电压低限位（0-10V）"-->
<!--              />-->
<!--            </a-form-model-item>-->
<!--          </a-col>-->
<!--        </a-row>-->
<!--        <a-row style='display: flex;width: 100%'>-->
<!--          <a-col :span="11">-->
<!--            <a-form-model-item-->
<!--              label="连续监测时间（S）"-->
<!--              prop="continuousMonitorTimeSeconds"-->
<!--            >-->
<!--              <a-input-number-->
<!--                v-model="form.continuousMonitorTimeSeconds"-->
<!--                :min="1"-->
<!--                style='width: 100%;'-->
<!--                placeholder="请输入连续监测时间（1-10001S）"-->
<!--              />-->
<!--            </a-form-model-item>-->
<!--          </a-col>-->
<!--        </a-row>-->
<!--      </a-page-header>-->
      <a-page-header
        title="设置系统开关"
        sub-title="Set system switches"
      >
        <a-row style='display: flex;width: 100%'>
          <a-col :span="24">
            <a-form-model-item
              label="开启功能设置"
              prop="setSystemFunctionSwitch"
            >
              <a-switch
                v-model="form.setSystemFunctionSwitch"
                checked-children="开"
                un-checked-children="关"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="测量牺牲阳极"
              prop="measureSacrificialAnodeSwitch"
            >
              <a-switch
                v-model="form.measureSacrificialAnodeSwitch"
                checked-children="开"
                un-checked-children="关"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="长期GPS时间同步"
              prop="longTermGpsTimeSynchronizationSwitch"
            >
              <a-switch
                v-model="form.longTermGpsTimeSynchronizationSwitch"
                checked-children="需要"
                un-checked-children="不需要"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style='display: flex;width: 100%'>
          <a-col :span="11">
            <a-form-model-item
              label="采样开始时"
              prop="samplingStartSwitch"
            >
              <a-switch
                v-model="form.samplingStartSwitch"
                checked-children="与GPS时间同步"
                un-checked-children="不与GPS时间同步"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item
              label="采集模式"
              prop="operatingMode"
            >
              <a-select v-model="form.operatingMode">
                <a-select-option :value="1" >模式1（测量通断电压、直流电流）</a-select-option>
                <a-select-option :value="2" >模式2（测量交流电压电流）</a-select-option>
                <a-select-option :value="3" >模式3（测量通电电压、自然电阻）</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-page-header>
      <a-page-header
        title="开机上报设备运行参数"
        sub-title="Report device operating parameters upon startup"
      >
        <a-row style='display: flex;width: 100%'>
          <a-col :span="24">
            <a-form-model-item
              label="开启功能设置"
              prop="startupReportRunDataFunctionSwitch"
            >
              <a-switch
                v-model="form.startupReportRunDataFunctionSwitch"
                checked-children="开"
                un-checked-children="关"
              />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-page-header>
      <div class="bottom-control">
        <a-space>
          <a-button
            type="primary"
            :loading="submitLoading"
            @click="submitForm"
          >
            保存
          </a-button>
          <a-button
            type="dashed"
            @click="cancel"
          >
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDeviceParam, updateDeviceParam } from '@/api/saifuneng/device'

export default {
  name: 'CreateParamForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      pipelineList: [],
      customList: [],
      deviceTypeList: [],
      interferenceTypeList: [],
      // 表单参数
      form: {
        deviceId: null,
        setTimeFunctionSwitch: null,
        setCurrentTime: null,
        onOffOnTime: null,
        collectParamFunctionSwitch: null,
        uploadCycleSeconds4g: null,
        onOffCycleSeconds: null,
        powerOutageIntervalMillisecond: null,
        powerOnDelayMillisecond: null,
        offDelayOperationMillisecond: null,
        lowPowerAcquisitionMinute: null,
        runTimeSeconds: null,
        setMonitorParamFunctionSwitch: null,
        alarmVoltageHighLimit: null,
        alarmVoltageLowLimit: null,
        continuousMonitorTimeSeconds: null,
        setSystemFunctionSwitch: null,
        measureSacrificialAnodeSwitch: null,
        longTermGpsTimeSynchronizationSwitch: null,
        samplingStartSwitch: null,
        operatingMode: null,
        startupReportRunDataFunctionSwitch: null,
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        deviceName: [
          { required: true, message: '设备名称不能为空', trigger: 'blur' }
        ],
        deviceCode: [
          { required: true, message: '设备编号不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {

  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        deviceId: null,
        setTimeFunctionSwitch: null,
        setCurrentTime: null,
        onOffOnTime: null,
        collectParamFunctionSwitch: null,
        uploadCycleSeconds4g: null,
        onOffCycleSeconds: null,
        powerOutageIntervalMillisecond: null,
        powerOnDelayMillisecond: null,
        offDelayOperationMillisecond: null,
        lowPowerAcquisitionMinute: null,
        runTimeSeconds: null,
        setMonitorParamFunctionSwitch: null,
        alarmVoltageHighLimit: null,
        alarmVoltageLowLimit: null,
        continuousMonitorTimeSeconds: null,
        setSystemFunctionSwitch: null,
        measureSacrificialAnodeSwitch: null,
        longTermGpsTimeSynchronizationSwitch: null,
        samplingStartSwitch: null,
        operatingMode: null,
        startupReportRunDataFunctionSwitch: null,
        remark: null
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    /** 修改按钮操作 */
    handleUpdate (id) {
      this.reset()
      this.formType = 2
      getDeviceParam({ "deviceId": id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '设置设备运行默认参数'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form.uploadCycleSeconds4g, ' this.form.uploadCycleSeconds4g');
      console.log(this.form.onOffCycleSeconds, ' this.form.onOffCycleSeconds');

      // if (this.form.onOffCycleSeconds * 1000 < this.form.powerOutageIntervalMillisecond) return this.$message.error('通电周期不能小于断电间隔')
      // if (this.form.lowPowerAcquisitionMinute == 0) {
      //   if (60 <= this.form.uploadCycleSeconds4g && this.form.uploadCycleSeconds4g <= 3600 && this.form.onOffCycleSeconds < 15) return this.$message.error('4G上传周期大于60小于3600,通断周期不能小于15')
      //   if (3600 < this.form.uploadCycleSeconds4g && this.form.uploadCycleSeconds4g <= 14400 && this.form.onOffCycleSeconds < 60) return this.$message.error('4G上传周期大于3600小于14400,通断周期不能小于60')
      //   if (14400 < this.form.uploadCycleSeconds4g && this.form.uploadCycleSeconds4g <= 28800 && this.form.onOffCycleSeconds < 180) return this.$message.error('4G上传周期大于14400小于28800,通断周期不能小于180')
      //   if (28800 < this.form.uploadCycleSeconds4g && this.form.uploadCycleSeconds4g <= 43200 && this.form.onOffCycleSeconds < 300) return this.$message.error('4G上传周期大于28800小于43200,通断周期不能小于300')
      //   if (43200 < this.form.uploadCycleSeconds4g && this.form.uploadCycleSeconds4g <= 57600 && this.form.onOffCycleSeconds < 360) return this.$message.error('4G上传周期大于43200小于57600,通断周期不能小于360')
      //   if (57600 < this.form.uploadCycleSeconds4g && this.form.uploadCycleSeconds4g <= 86400 && this.form.onOffCycleSeconds < 480) return this.$message.error('4G上传周期大于57600小于86400,通断周期不能小于480')
      //
      // } else {
      //   // if()
      //   if (28800 < this.form.uploadCycleSeconds4g && this.form.uploadCycleSeconds4g <= 43200 && this.form.powerOnDelayMillisecond < 3) return this.$message.error('4G上传周期大于28800小于43200,通电延时不能小于3')
      //
      //   // return this.$message.error('更新数据===')
      // }
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.deviceId !== undefined && this.form.deviceId !== null) {
            this.form.setTimeFunctionSwitch = this.form.setTimeFunctionSwitch ? 1 : 0
            this.form.collectParamFunctionSwitch = this.form.collectParamFunctionSwitch ? 1 : 0
            this.form.setMonitorParamFunctionSwitch = this.form.setMonitorParamFunctionSwitch ? 1 : 0
            this.form.setSystemFunctionSwitch = this.form.setSystemFunctionSwitch ? 1 : 0
            this.form.measureSacrificialAnodeSwitch = this.form.measureSacrificialAnodeSwitch ? 1 : 0
            this.form.longTermGpsTimeSynchronizationSwitch = this.form.longTermGpsTimeSynchronizationSwitch ? 1 : 0
            this.form.samplingStartSwitch = this.form.samplingStartSwitch ? 1 : 0
            this.form.startupReportRunDataFunctionSwitch = this.form.startupReportRunDataFunctionSwitch ? 1 : 0
            updateDeviceParam(this.form).then(response => {
              this.$message.success(
                '设置成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },

    onChange (checked) {
      console.log(checked)
    }


  }
}
</script>
